import { render, staticRenderFns } from "./uploadProperty.vue?vue&type=template&id=6398d70b"
import script from "./uploadProperty.vue?vue&type=script&lang=js"
export * from "./uploadProperty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports